export const enChat = {
  title: "Ask Olive",
  inputPlaceholder: "Ask anything about your data...",
  domainSelectAria: "Select domain",
  sendAria: "Send message",
  stopButton: "Stop generating",
  processingTitle: "Processing your question...",
  processingWaiting: "Analyzing your question...",
  assistantPlaceholder: "Analysis complete.",
  response: {
    tabs: {
      insights: "Insights",
      howGenerated: "How it was generated",
      table: "Table",
      data: "Table",
      chart: "Charts",
      cards: "Cards",
      sql: "SQL",
      followUps: "Follow-ups",
    },
    howGenerated: {
      request: "Request",
      response: "Response",
    },
    followUps: {
      suggested: "Suggested follow-ups",
    },
    sections: {
      insights: "Insights",
      why: "Why",
      action: "Action",
      businessImpact: "Business Impact",
    },
    tables: {
      addToApp: "Add to app",
    },
    cards: {
      addToApp: "Add to app",
    },
    sql: {
      multiTableBadge: "Multi-table",
      multiTableTooltip: "Combines measures across multiple tables: {{tables}}",
      multiTableTooltipGeneric: "Combines measures across multiple physical tables",
    },
    confidence: {
      levels: {
        high: "High confidence ({{score}}%)",
        medium: "Medium confidence ({{score}}%)",
        low: "Low confidence ({{score}}%)",
      },
      noSignals: "No validation issues detected.",
    },
    documents: {
      sourcesTitle: "Document sources",
      agreement: {
        supports: "Documents support this answer",
        complements: "Documents add context",
        conflicts: "Documents disagree with the data",
        document_only: "Answered from documents",
      },
      conflictTitle: "Data and documents disagree",
      conflictHelp:
        "Warehouse data is the authoritative source. The document figures are shown so you can see the difference.",
      ambiguityTitle: "Ambiguous data — same period, different values",
      ambiguityHelp:
        "Both sources describe the same period and report different values, so this figure is unconfirmed. Check it before acting on either number.",
      samePeriodNoCause: "No explanation for the difference could be identified.",
      dataSays: "Data",
      documentsSay: "Documents",
      likelyCause: "Likely cause",
      page: "p. {{page}}",
      pagePreviewsTitle: "Cited pages",
      expandPage: "Enlarge page",
      collapsePage: "Shrink page",
    },
    charts: {
      chartType: "Chart type",
      expand: "Expand chart",
      download: "Download chart",
      downloadPng: "Download PNG",
      downloadJpg: "Download JPG",
      close: "Close expanded chart",
      addToApp: "Add to app",
      types: {
        line: "Line",
        bar: "Bar",
        area: "Area",
        pie: "Pie",
        scatter: "Scatter",
        combo: "Combo",
      },
    },
    feedback: {
      thumbUpAriaLabel: "Mark this response as helpful",
      thumbDownAriaLabel: "Mark this response as not helpful",
      thumbUpTooltip: "Helpful",
      thumbDownTooltip: "Not helpful",
      commentHeadingUp: "What made this useful?",
      commentHeadingDown: "What missed the mark?",
      commentSubheading: "Optional — your feedback is already saved.",
      commentPlaceholderUp: "e.g. spotted a trend we hadn't noticed",
      commentPlaceholderDown: "e.g. the numbers look wrong",
      commentAriaLabel: "Additional feedback about this response",
      commentError: "Could not save your comment. Please try again.",
      skip: "Skip",
      submit: "Submit",
    },
  },
  errorTitle: "Something went wrong",
  terminated: {
    title: "Conversation terminated",
    message: "This response was stopped before it could finish. Review the generation steps to see what completed before stopping.",
    howGenerated: "Generation stopped at this point.",
  },
  backAria: "Back to chat history",
  history: {
    pageTitle: "Chat History",
    searchPlaceholder: "Search your Chats...",
    newChat: "New Chat",
    terminated: "Stopped",
    untitled: "Untitled chat",
    menuAria: "Chat options for {{title}}",
    editTitle: "Edit Title",
    delete: "Delete",
    empty: "No chats yet. Start a new chat to begin.",
    noSearchResults: "No chats match your search.",
    editTitleModal: {
      title: "Edit Title",
      label: "Chat title",
      closeAria: "Close",
      cancel: "Cancel",
      save: "Save",
      validation: {
        required: "Title is required",
      },
      errors: {
        saveFailed: "Could not update the chat title.",
      },
    },
    deleteConfirm: {
      title: "Delete chat?",
      message: "This chat and all its messages will be permanently deleted.",
      cancel: "Cancel",
      confirm: "Delete",
      closeAria: "Close",
      errors: {
        deleteFailed: "Could not delete the chat.",
      },
    },
  },
} as const;
